module.exports = __webpack_public_path__ + "WorkSans-SemiBold.6ae86405365767c10f7e.ttf";


//////////////////
// WEBPACK FOOTER
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/assets/fonts_v2/Work_Sans/WorkSans-SemiBold.ttf
// module id = ../../../../../src/assets/fonts_v2/Work_Sans/WorkSans-SemiBold.ttf
// module chunks = styles